module.exports = __webpack_public_path__ + "img/mega.b1a873ef.jpg";